import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

export interface TextProps {
  children: string | ReactNode;
}

const Text: React.FC<TextProps> = ({ children }: TextProps) => {
  return (
    <Typography component="p" margin="1rem 0" fontSize="1.2rem">
      {children}
    </Typography>
  );
};

export default Text;
